export default "__VITE_ASSET__82e3d69c__"